<script setup lang="ts">
import { AccountIcon } from '@taler/ui'

/**
 * An account's identity: its own icon on a tint of its own user-chosen colour. Decorative - the
 * account's name always sits beside it - and the colour never reaches text or a figure.
 */
defineProps<{ icon: string | undefined; color: string | undefined }>()
</script>

<template>
  <span
    v-if="icon !== undefined && color !== undefined"
    aria-hidden="true"
    class="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded-[5px] [&_svg]:h-3 [&_svg]:w-3"
    :style="{ background: `color-mix(in srgb, ${color} 18%, var(--color-surface))`, color }"
  >
    <AccountIcon :icon="icon" label="" />
  </span>
</template>
